// NPM Modules
import React from 'react';
import { browserHistory } from 'react-router';
import Spinner from 'react-spin';
import R from 'ramda';

// Modules
import Firebase from '../modules/FirebaseApp';
import Input from './Input';
import Checkbox from './Checkbox';

import '../styles/recipedia.css';

// Generate Random Pass
function generateRandomPass(email) {
  var chars = "0123456789abcdefghijklmnopqrstuvwxyz-ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  var randomPass = "";
  for (let i = 0; i < 32; i++) {
    randomPass += chars[Math.floor(Math.random() * chars.length)];
  }
  return randomPass;
}

// Help
function help(email) {
  return `recipedia-${email.split("@")[0].toLowerCase()}`;
}

// Get URL Params
function getUrlParameter(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const isInvalidEmail = (value) => !emailRegex.test(value);
const containsInvalidChar = (value) => /[+&]/.test(value);

const emailChecker = R.cond([
  [isInvalidEmail, R.always('Please enter a valid email address')],
  [containsInvalidChar, R.always('Emails must not contain the + character')],
  [R.T, R.always(null)]
]);

const nameChecker = (label) => R.cond([
  [R.equals(''), R.always(`${label} cannot be empty`)],
  [containsInvalidChar, R.always(`${label} must not contain the character '+' or '&'`)],
  [R.T, R.always(null)]
]);

const errorCheckers = {
  over16Confirmed: (value) => value ? null : 'You must confirm that you are over 16 to link your account',
  firstName: nameChecker('First name'),
  lastName: nameChecker('Last name'),
  email: emailChecker
};

/**
 * A function to take in form field and generate any necessary validation error message.
 * 
 * @param {string} formFieldName - Name of form field being tested
 * @param {string | boolean} formFieldValue - Value of form field being tested
 * 
 * @returns {string | null} - Either null for no errors or a string with an error message
 */
const checkForError = (formFieldName, formFieldValue) => errorCheckers[formFieldName] ? (errorCheckers[formFieldName](formFieldValue)) : null;

/**
 * A function to take in an entire object of form data and output a mirror object of any validation error messages
 * 
 * @param {object} formData - Keys of form field names and values of form field values
 * 
 * @returns {object} Keys of form field names and values of error messages or null
 */
const validateForm = (formData) => 
  Object.entries(formData)
    .reduce((errorsObject, [formFieldName, formFieldValue]) => 
      Object.assign(errorsObject, { [formFieldName]: checkForError(formFieldName, formFieldValue)}), {});


class AccountLink extends React.Component {
  constructor() {
    super();
    this.state = {
      formPristine: true,
      submitting: false,
      error: false,
      formData: {
        over16Confirmed: false,
        recipeEmails: false,
        marketingEmails: false,
        firstName: '',
        lastName: '',
        email: '',
        country: 'GB',
        language: 'EN'
      },
      formErrors: {}
    };
  }

  handleChange({ target: { name, value, type, checked }}) {
    // This event has to be fired only once, so it fires on the first change of a form field
    if (this.state.formPristine) {
      console.log('Fire the event!');
      var ev = {};
      ev.eventInfo={
        'type':ctConstants.trackEvent,
        'eventAction': ctConstants.RegistrationStart,
        'eventLabel' : window.location.href,
        'eventValue' :1
      };
      ev.category ={'primaryCategory':ctConstants.other};                        
      ev.subcategory = 'Lead';
      digitalData.event.push(ev);
    }
    this.setState(prevState => {
      const newState = Object.assign({}, prevState);
      newState.formPristine = false;
      newState.formData[name] = (type === 'checkbox') ? checked : value;
      newState.formErrors[name] = checkForError(name, newState.formData[name]);
      return newState;
    });
  }

  submitForm() {
    this.setState(prevState => Object.assign({}, prevState, { formErrors: validateForm(prevState.formData) }), 
    () => {
      const formIsValid = Object.entries(this.state.formErrors).filter(entry => Boolean(entry[1])).length === 0;
      if (formIsValid) {
      // START OLD CODE >>>>>>
      this.setState({
          submitting: true,
          canSubmit: false
      });
      var alexaClientId = getUrlParameter('client_id');
      var state = getUrlParameter('state');
      var redirectURI = getUrlParameter('redirect_uri');

      const { formData: data } = this.state;

      if (alexaClientId === 'recipedia-alexa') {
        // Create User
        Firebase.auth().createUserWithEmailAndPassword(data.email, help(data.email))
          .then((user) => {
            // Create Database Record
            Firebase.database().ref(`userData/${user.uid}`).set(data)
            .then(() => {
              // Adobe Analytics code (relies on the global scope)
              var ev = {};
              ev.eventInfo={
                'type':ctConstants.trackEvent,
                'eventAction': ctConstants.registration,
                'eventValue' :1                                                                                                                                                                                                                                                                                                                                       };
              ev.category ={'primaryCategory':ctConstants.other};
              console.log('Submitting analytics event!');
              digitalData.event.push(ev);
              // End Adobe Analytics code
              user.sendEmailVerification()
                .then(() => {
                  user.updateProfile({ displayName: data.firstName });
                  var redirect = `${redirectURI}#state=${state}&access_token=${user.uid}&token_type="Bearer"`;
                  if (navigator.userAgent.match(/Android/i)) {
                    document.location = redirect;
                  }
                  else {
                    location.replace(redirect);
                  }
                });
            });
          })
          .catch((error) => {

            // User Already Exists
            if (error.code === "auth/email-already-in-use") {
              var tmp = help(data.email);
              Firebase.auth().signInWithEmailAndPassword(data.email, tmp)
                .then((signedInUser) => {
                  // Create Database Record
                  Firebase.database().ref(`userData/${signedInUser.uid}`).set(data)
                  .then(() => {
                    signedInUser.sendEmailVerification()
                      .then(() => {
                        signedInUser.updateProfile({ displayName: data.name });
                        var redirect = `${redirectURI}#state=${state}&access_token=${signedInUser.uid}&token_type="Bearer"`;
                        if (navigator.userAgent.match(/Android/i)) {
                          document.location = redirect;
                        }
                        else {
                          location.replace(redirect);
                        }
                      });
                  });
                })
                .catch((error) => {
                      this.setState({
                        submitting: false,
                        canSubmit: true,
                        error: error.message
                      });
                    });
                }
                else {
                  this.setState({
                    submitting: false,
                    canSubmit: true,
                    error: error.message
                  });
                }
              });
          }
          else {

            this.setState({
              submitting: false,
              canSubmit: true,
              error: 'Invalid Client ID.'
            });
          }
        // END OLD CODE <<<<<<<<
      } else {
      };
    });
  }

  render() {
      const { formData, formErrors } = this.state;

      const spinCfg = {
        width: 6,
        radius: 15,
        color: '#00c1e0'
      };
  
      return (
        <div className="main">
          <div id="top" className="landing-main">
            <div className="container text-vertical-center">
              <center><img src="https://s3.eu-west-2.amazonaws.com/recipedia/recipedia-logo.jpeg" className="recipedia-logo img-responsive" alt="Recipedia Logo"></img></center>
              <h3 className="white">The Recipedia Skill for Amazon Alexa</h3>
  
              <h4 className="white">Fill in your details to get started:</h4>
              <h5><strong className="yellow">(Make sure you verify your email by clicking the link in the email we send you.)</strong></h5>
  
              <div className="row">
                <div className="col-sm-6 col-sm-offset-3">
                  <Input
                    value={formData.firstName} 
                    changeValue={(e) => this.handleChange(e)} 
                    name="firstName" 
                    title="First name" 
                    asterix="*"
                    errorMessage={formErrors.firstName}
                  />
                  <Input
                    value={formData.lastName}
                    changeValue={(e) => this.handleChange(e)} 
                    name="lastName" 
                    title="Last name" 
                    asterix="*" 
                    errorMessage={formErrors.lastName}
                  />
                  <Input 
                    value={formData.email} 
                    changeValue={(e) => this.handleChange(e)} 
                    name="email" 
                    title="Email (no spaces before/after email allowed)" 
                    asterix="*"
                    errorMessage={formErrors.email}
                  />

                  <div className="opt-in-wrapper">
                    <Checkbox value={formData.over16Confirmed} changeValue={(e) => this.handleChange(e)} name="over16Confirmed" title="Yes – I confirm that I am over 16 years old " asterix="*" errorMessage={formErrors.over16Confirmed}/>

                    <Checkbox value={formData.recipeEmails} changeValue={(e) => this.handleChange(e)} name="recipeEmails" title="Yes – I want to receive information from Recipedia about recipes"/>

                    <Checkbox value={formData.marketingEmails} changeValue={(e) => this.handleChange(e)} name="marketingEmails" title="Yes – Share my data with other Unilever brands to receive the latest news on other Unilever products and services"/>
                  </div>
                  
                  {(this.state.error !== false) ? <div class="alert alert-danger"><strong>Error: </strong>{this.state.error}</div> : ''}

                  <br />
                  <p className="white center">Please read our Privacy and Cookie notices to understand how we use your personal data</p>

                  <p className="white center">By clicking the below button, you agree to our <a className="recipedia-link" href="http://www.unileverprivacypolicy.com/en_gb/policy.aspx" target="_blank">Terms and Conditions</a>.</p>

                  <button className="btn btn-info" type="submit" onClick={() => this.submitForm()}>Submit</button>
  
                  {this.state.submitting ? <Spinner config={spinCfg} /> : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
  }
}


  // submit(data) {

    
// });

export default AccountLink;



// WEBPACK FOOTER //
// ./src/components/AccountLink.js